import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group } from "@shared/models/group"
import type { Planbook } from "@shared/models/planbook"
import { PLANBOOK_ROLES } from "@shared/models/planbook"
import LiveQueryResource from "cc-frontend/helpers/live-query"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import type Session from "cc-frontend/services/session"
import { use } from "ember-could-get-used-to-this"
import { find, isNil } from "lodash-es"
import { tracked } from "tracked-built-ins"

interface Args {
  planbook: Planbook
}

export default class AddGroups extends Component<Args> {
  @service("ember-store") store!: EmberStore
  @service session!: Session
  @service rpc!: Rpc

  availableRoles = PLANBOOK_ROLES
  @tracked showShareGroupForm = false
  @tracked selectedRole = find(PLANBOOK_ROLES, { id: "EDITOR" })
  @tracked selectedGroup: Group | null = null

  @use query = new LiveQueryResource(() => ["invitable_groups_for_user", this.session.userId])

  @action
  onShowShareGroupForm() {
    this.showShareGroupForm = true
  }

  @action hideShareGroupForm() {
    this.showShareGroupForm = false
  }

  @action
  selectGroup(group) {
    this.selectedGroup = group
  }

  @action
  changeRole(role) {
    this.selectedRole = role
  }

  @action
  addGroupCollaborator() {
    if (isNil(this.selectedGroup) || isNil(this.selectedRole)) return
    let role = this.selectedRole?.id || "EDITOR"
    this.rpc.planbook_collaboration_add_group({
      planbookId: this.args.planbook.id,
      groupId: this.selectedGroup?.id,
      role: role,
    })
    this.selectedGroup = null
    this.selectedGroup = null
    this.selectedRole = find(this.availableRoles, { id: "EDITOR" })
    this.showShareGroupForm = false
  }
}
